export default __webpack_public_path__ + "static/media/Pot1.430ec954.svg";